(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ay-jp-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ay-jp-hero-motion')) {
  customElements.define('ay-jp-hero-motion', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.mobile = window.matchMedia('(max-width: 767px)');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = true;
      const poster = this.closest('.ay-jp-hero__media').querySelector('img');
      this.posterReady = !poster || poster.complete;
      this.sync = () => {
        const src = this.mobile.matches ? this.dataset.mobileSrc : this.dataset.desktopSrc;
        const blocked = this.reduced.matches || (navigator.connection && navigator.connection.saveData);
        if (!src || blocked) {
          this.video.pause();
          this.video.removeAttribute('src');
          this.video.load();
          this.classList.remove('is-playing');
          return;
        }
        if (!this.posterReady) return;
        if (this.video.getAttribute('src') !== src) {
          this.classList.remove('is-playing');
          this.video.src = src;
          this.video.muted = true;
        }
        if (this.visible && !document.hidden) {
          this.video.play().catch(() => {
            if (this.visible && !document.hidden && !this.video.error) {
              this.classList.remove('is-playing');
            }
          });
        } else {
          this.video.pause();
        }
      };
      this.video.addEventListener('playing', () => {
        this.classList.add('is-playing');
      }, options);
      this.video.addEventListener('error', () => {
        this.classList.remove('is-playing');
      }, options);
      if (poster && !this.posterReady) {
        const posterReady = () => { this.posterReady = true; this.sync(); };
        poster.addEventListener('load', posterReady, options);
        poster.addEventListener('error', posterReady, options);
      }
      this.mobile.addEventListener('change', this.sync, options);
      this.reduced.addEventListener('change', this.sync, options);
      document.addEventListener('visibilitychange', this.sync, options);
      if (navigator.connection) navigator.connection.addEventListener('change', this.sync, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.sync();
      });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.controller.abort();
      this.observer.disconnect();
      this.video.pause();
      this.video.removeAttribute('src');
      this.video.load();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
